import { Section } from '@/courses/models/section.model';
import { CourseTemplateMode } from '../types/course-template.type';
import { ResponseCourseTemplates } from './response-course-templates.model';
import { SchoolDays } from '@/tools/models/school-days.model';

export class CourseTemplate {
  
  categories: any[];
  id: number;
  coverUrl: string;
  description: string;
  courseId: number; 
  publisher: {
    id: number;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
  };
  thumbnailUrl: string;
  title: string;
  isPublic: boolean;
  published: boolean;
  sections: Section[] = [];
  materials = { materials: [], nodes: [] };
  materialsList: any[] = [];
  projects: any[];
  defaultDueDateForTasks: number;
  defaultLastDateForTasks: number;
  locked: boolean;
  userType: string;
  duration : number;
  schoolCalendar: SchoolDays;
  status: 'COPYING' | 'READY' | 'ERROR';

  constructor(data?: ResponseCourseTemplates | CourseTemplate) {
    if(data) {
      if(data instanceof ResponseCourseTemplates) {
        this.setFromResponseCourseTemplates(data);
      } else {
        this.setCourseTemplate(data);
      }
    }
  }

  get isReady() {
    return this.status === 'READY';
  }

  get isCopying() {
    return this.status === 'COPYING';
  }

  get hasError() {
    return this.status === 'ERROR';
  }

  private setFromResponseCourseTemplates(data: ResponseCourseTemplates) {
    this.id = data.courseTemplateId;
    this.categories = data.categories;
    this.coverUrl = data.coverUrl;
    this.description = data.description;
    this.courseId = data.originalCourseId;
    this.publisher = data.publisher;
    this.thumbnailUrl = data.thumbnailMediumUrl;
    this.title = data.title;
    this.isPublic = data.publicTemplate;
    this.published = data.published;
    this.locked = data.locked;
    this.userType = data.userType;
    this.duration = data.duration;
    this.schoolCalendar = data.schoolCalendar;
    this.status = data.status;
  }

  private setCourseTemplate(data: CourseTemplate) {
    Object.assign(this, data);
  }

}

export class CourseTemplateInfo {
  data: CourseTemplate;
  mode: CourseTemplateMode;
  component: any;
}

export class CourseTemplateSection {
  data: Section;
  opened: boolean;
  selected: boolean;
  viewer?: any;
  minDate: string;
}